module.exports = __webpack_public_path__ + "static/img/icon_wifi mall@2x.69423da5.png";